document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const menuButton = document.querySelector('[data-menu-button]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const dialog = document.querySelector('[data-product-dialog]');
  const closeButton = document.querySelector('[data-dialog-close]');

  window.addEventListener('scroll', () => header?.classList.toggle('is-scrolled', window.scrollY > 12), { passive: true });

  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
  mobileMenu?.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => {
    mobileMenu.hidden = true;
    menuButton?.setAttribute('aria-expanded', 'false');
  }));

  const dataNode = document.getElementById('AmamiaProductData');
  let products = {};
  if (dataNode) {
    try { products = JSON.parse(dataNode.textContent); } catch (e) { console.warn('AMAMIA product data could not be parsed', e); }
  }
  const colorClasses = { 'Soft Sand':'sand', 'Warm Ivory':'ivory', 'Dusty Rose':'rose', 'Sea Mist':'mist', 'Stone':'stone', 'Midnight':'midnight' };

  document.querySelectorAll('[data-product-open]').forEach((button) => button.addEventListener('click', () => openProduct(button.dataset.productOpen)));
  closeButton?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  dialog?.addEventListener('close', () => document.body.classList.remove('dialog-open'));
  document.querySelector('[data-dialog-waitlist]')?.addEventListener('click', () => dialog?.close());

  function openProduct(key) {
    const p = products[key];
    if (!p || !dialog) return;
    dialog.querySelector('[data-dialog-index]').textContent = p.index;
    dialog.querySelector('[data-dialog-title]').textContent = p.title;
    dialog.querySelector('[data-dialog-subtitle]').textContent = p.subtitle;
    dialog.querySelector('[data-dialog-description]').textContent = p.description;
    dialog.querySelector('[data-dialog-material]').textContent = p.material;
    dialog.querySelector('[data-dialog-fit]').textContent = p.fit;
    dialog.querySelector('[data-dialog-sizes]').textContent = p.sizes;
    dialog.querySelector('[data-dialog-lengths]').textContent = p.lengths;
    const life = dialog.querySelector('[data-dialog-lifestyle]');
    life.src = p.lifestyle; life.alt = p.title + ' Lifestyle';
    const flat = dialog.querySelector('[data-dialog-flat]');
    flat.src = p.flat; flat.alt = p.title + ' Produktansichten';
    const ul = dialog.querySelector('[data-dialog-features]');
    ul.replaceChildren(...p.features.map((v) => { const li = document.createElement('li'); li.textContent = v; return li; }));
    const colors = dialog.querySelector('[data-dialog-colors]');
    colors.replaceChildren(...p.colors.map((v) => {
      const span = document.createElement('span');
      const i = document.createElement('i');
      i.className = colorClasses[v] || 'sand';
      span.append(i, document.createTextNode(v));
      return span;
    }));
    const cta = dialog.querySelector('[data-dialog-product-link]');
    if (p.url) {
      cta.href = p.url;
      cta.textContent = p.cta || 'Zum Produkt';
      cta.hidden = false;
    } else {
      cta.hidden = true;
    }
    document.body.classList.add('dialog-open');
    dialog.showModal();
  }

  document.querySelectorAll('[data-year]').forEach((el) => { el.textContent = new Date().getFullYear(); });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delay = Number(entry.target.dataset.delay || 0);
        setTimeout(() => entry.target.classList.add('is-visible'), delay);
        observer.unobserve(entry.target);
      }
    }), { threshold: .08 });
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }
});
